import onboardingImageUrl from "@/assets/images/onboarding.webp?url";

export default function SignupImage() {
  return (
    <div className="p-6 hidden md:block flex-1">
      <img
        src={onboardingImageUrl}
        className="size-full rounded-2xl object-cover object-left"
      />
    </div>
  );
}
